<template>
  <div>
    <el-card class="el-card-class">
      <el-radio-group v-model="feedBackType" style="margin-top:2px">
        <el-radio @click="feedBackExam" label="hasExam" style="margin-left: 10px"
                  v-if="chooseType==='' || chooseType==='exam'">
          考过此题
          <el-tooltip content="您的真实反馈对其他考生有很大的帮助，赠人玫瑰手有余香，每一份善意皆会化作回报，愿您所到之处皆有人助"
                      placement="bottom">
            <!--            <i class="el-icon-question"/>-->
            <el-icon>
              <QuestionFilled/>
            </el-icon>
          </el-tooltip>
        </el-radio>
        <el-radio @click="feedBackError" label="hasError" style="float: left;margin-left: 20px"
                  v-if="chooseType==='' || chooseType==='error'">纠错此题
        </el-radio>

        <el-radio @click="feedBackNew" label="newQuestion" style="float: left;margin-left: 20px"
                  v-if="chooseType==='' || chooseType==='question'">新考题
          <el-tooltip content="创建不在系统内的考题，此考题会加入您的自定义题库"
                      placement="bottom">
            <el-icon>
              <QuestionFilled/>
            </el-icon>
          </el-tooltip>
        </el-radio>
        <el-radio @click="feedBackSuggestion" label="hasSuggestion" style="float: left;margin-left: 20px"
                  v-if="chooseType==='' || chooseType==='suggestion'">建议
          <el-tooltip content="请畅所欲言，小助会认真听取您的建议"
                      placement="bottom">
            <el-icon>
              <QuestionFilled/>
            </el-icon>
          </el-tooltip>
        </el-radio>
      </el-radio-group>
    </el-card>
    <el-card class="el-card-class">
      <el-form :model="feedbackForm" :rules="feedBackRules" ref="feedbackForm"
               style="text-align: center">
        <el-form-item label="考试日期" prop="examDate" v-if="hasExam">
          <el-date-picker v-model="feedbackForm.examDate" type="datetime" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="hasError" prop="errorReason">
          <el-input maxlength="100"
                    type="textarea"
                    v-model="feedbackForm.errorReason"
                    placeholder="请输入正确回答及原因"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="newQuestion" label="题目" prop="newQuestionTitle">
          <el-input type="text" v-model="feedbackForm.newQuestionTitle"></el-input>
        </el-form-item>

        <el-form-item
            v-if="newQuestion && (questionType==='recognize'||questionType==='operation'||questionType==='oral')"
            label="题目语音" prop="newQuestionTitle">
          <audio v-if="hasTitleRecord" ref="titlePlayer" :src="titlePlayerUrl" controls
                 @pause="titlePlayerPause" @play="titlePlay"></audio>
          <el-button type="primary" size="small" @click="titleText2Audio" v-if="!hasTitleRecord">AI生成语音</el-button>
          <el-button size="small" type="primary" @click="recordTitleAudio" v-if="!hasTitleRecord">点击录制
          </el-button>
          <el-upload style="margin-top: 10px;margin-left: 20px"
                     action="#"
                     :before-upload="beforeAudioUpload"
                     :http-request="uploadTitleAudio"
                     v-if="!hasTitleRecord"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <el-button size="small" type="primary" @click="removeTitleAudio" v-if="hasTitleRecord">删除录音</el-button>
        </el-form-item>
        <el-form-item
            v-if="newQuestion && (questionType==='recognize'||questionType==='operation'||questionType==='oral')"
            label="答案" prop="newQuestionAnswerText">
          <el-input type="textarea" maxlength="100" v-model="feedbackForm.newQuestionAnswerText"></el-input>
        </el-form-item>
<!--        <el-form-item-->
<!--            v-if="newQuestion && questionType==='oral'"-->
<!--            label="语音答案" prop="newQuestionAnswerAudio">-->
<!--          <audio v-if="hasAnswerRecord" ref="answerPlayer" :src="answerPlayerUrl" controls-->
<!--                 @pause="answerPlayerPause" @play="answerPlay"></audio>-->
<!--          <el-button type="primary" size="small" @click="answerText2Audio" v-if="!hasAnswerRecord">AI生成语音</el-button>-->
<!--          <el-button size="small" type="primary" @click="recordAnswerAudio" v-if="!hasAnswerRecord">点击录制-->
<!--          </el-button>-->
<!--          <el-upload style="margin-top: 10px;margin-left: 20px"-->
<!--                     action="#"-->
<!--                     :before-upload="beforeAudioUpload"-->
<!--                     :http-request="uploadAnswerAudio"-->
<!--                     v-if="!hasAnswerRecord"-->
<!--          >-->
<!--            <el-button size="small" type="primary">点击上传</el-button>-->
<!--          </el-upload>-->
<!--          <el-button size="small" type="primary" @click="removeAnswerAudio" v-if="hasAnswerRecord">删除录音</el-button>-->
<!--        </el-form-item>-->
        <el-form-item
            v-if="newQuestion && (questionType==='recognize'||questionType==='operation'||questionType==='oral')"
            label="图片" prop="newQuestionPicture">
          <el-upload
              class="image-uploader"
              action="#"
              list-type="picture-card"
              :before-upload="beforeUpload"
              :http-request="uploadPicture"
              :on-exceed="limitError"
              :on-remove="removePicture"
              :limit="1">
            <div>
              <em>将图片拖到此处，或点击选取,仅可上传一张小于5M的图片</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="hasSuggestion" prop="newSuggestion">
          <el-input type="textarea" maxlength="100" v-model="feedbackForm.newSuggestion"
                    placeholder="请输入您的宝贵建议"></el-input>
        </el-form-item>
      </el-form>
      <el-form-item
          v-if="newQuestion && (questionType==='singleChoice'||questionType==='multiChoice'||questionType==='judgement')"
          label="选项" prop="newQuestionOptions">
        <el-table :data="feedbackForm.newQuestionOptions">
          <el-table-column label="选项内容" prop="content" width="300px">
            <template #default="scope">
              <el-input v-model="scope.row.content"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否答案" prop="isAnswer" width="100px">
            <template #default="scope">
              <el-select v-model="scope.row.answer">
                <el-option key="1" label="是" :value=true></el-option>
                <el-option key="2" label="否" :value=false></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100px">
            <template #default="scope">
              <el-button v-if="questionType === 'multiChoice'" @click="removeOption(scope.$index)" type="warning"
                         size="small">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-if="questionType === 'multiChoice'" type="primary" @click="addOption">添加选项</el-button>
      </el-form-item>

    </el-card>
    <el-dialog v-model="showTitleRecord" title="录音" append-to-body style="width: 320px">
      <recordComponents @submitRecord:value="handleTitleRecordDialog"></recordComponents>
    </el-dialog>
    <el-dialog v-model="showAnswerRecord" title="录音" append-to-body style="width: 320px">
      <recordComponents @submitRecord:value="handleAnswerRecordDialog"></recordComponents>
    </el-dialog>


    <!--    <template #footer>-->
    <!--      -->
    <!--    </template>-->
    <el-button type="success" @click="submitFeedBack" style="float:right;margin-right: 30px">确定</el-button>
  </div>
</template>

<script>

import {ElMessage} from "element-plus";
import request from "@/utils/request";
import router from "@/router";
// import {useRoute} from "vue-router/dist/vue-router";
import {ref} from "vue";
import recordComponent from "@/components/Record"


const loginUserId = localStorage.getItem("loginUserId");

function text2AudioAnswer(feedBackForm) {
  request.post('/userFeedBackInfo/text2audio',
      {
        userId: loginUserId,
        answerText: feedBackForm.newQuestionAnswerText,
        answerAudioPath: feedBackForm.newQuestionAnswerAudio,
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        responseType: 'blob'
      }).then(response => {
    if (response.status === 200) {
      const result = response.data; // 将接口返回的数据赋值给result
      const header = response.headers;
      const params = header["content-disposition"]
          .split(';')
          .map(param => param.trim())
          .reduce((acc, part) => {
            const [key, value] = part.split('=');
            acc[key] = value;
            return acc;
          }, {});

      newQuestionAnswerAudio.value = params['fileName'];
      answerPlayerUrl.value = URL.createObjectURL(result);
    } else {
      router.push("/login");
    }
  })
      .catch(error => {
        console.log("feedback error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function text2AudioTitle(feedBackForm) {
  request.post('/userFeedBackInfo/text2audio',
      {
        userId: loginUserId,
        title: feedBackForm.newQuestionTitle,
        titleAudioPath: feedBackForm.newQuestionTitleAudio,
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        responseType: 'blob'
      }).then(response => {
    if (response.status === 200) {
      const result = response.data; // 将接口返回的数据赋值给result
      const header = response.headers;
      const params = header["content-disposition"]
          .split(';')
          .map(param => param.trim())
          .reduce((acc, part) => {
            const [key, value] = part.split('=');
            acc[key] = value;
            return acc;
          }, {});
      newQuestionTitleAudio.value = params['filename'];
      // titlePlayerUrl.value = result.data.audioContent;
      titlePlayerUrl.value = URL.createObjectURL(result);
    } else {
      router.push("/login");
    }
  })
      .catch(error => {
        console.log("feedback error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

async function deleteAudioFromServer(audioPath, type) {
  await request.delete(`/userFeedBackInfo/deleteAudio/${loginUserId}`,
      {
        data: {
          titleAudioPath: audioPath
        }
      }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code === "200") {
      ElMessage.success("删除成功");
      if (type === "title") {
        hasTitleRecord.value = false;
        newQuestionTitleAudio.value = '';
      }
      if (type === "answer") {
        hasAnswerRecord.value = false;
        newQuestionAnswerAudio.value = '';
      }
    } else {
      ElMessage.warning(result.msg);
    }
  }).catch(error => {
    console.log("uploadPicture error:" + error);
    // ElMessage.error("系统异常，请联系管理员");
  });
}

async function uploadRecord(file, type) {
  const formData = new FormData();
  formData.append("file", file, Date.now() + ".mp3");
  formData.append("type", type);
  formData.append("userId", loginUserId);
  // formData.append("paperId",paperId);

  await request.post('/userFeedBackInfo/uploadAudio', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code === "200") {
      if (type === "title") {
        newQuestionTitleAudio.value = result.data;
        titlePlayerUrl.value = URL.createObjectURL(file);
      }
      if (type === "answer") {
        newQuestionAnswerAudio.value = result.data;
        answerPlayerUrl.value = URL.createObjectURL(file);
      }
    } else {
      ElMessage.warning(result.msg);
    }
  }).catch(error => {
    console.log("uploadRecord error:" + error);
    // ElMessage.error("系统异常，请联系管理员");
  });
}

async function uploadPictureToServer(file) {
  const formData = new FormData();
  formData.append("userId", loginUserId);
  formData.append("file", file.file, Date.now() + "." + file.file.type.replace("image/", ""));
  // formData.append("paperId",paperId);
  // formData.append("questionId", this.questionId);

  await request.post('/userFeedBackInfo/uploadPicture', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code === "200") {
      this.feedbackForm.newQuestionPicture = result.data;
    } else {
      ElMessage.warning(result.msg);
    }
  }).catch(error => {
    console.log("uploadPicture error:" + error);
    // ElMessage.error("系统异常，请联系管理员");
  });
}

async function deletePictureFromServer() {
  await request.delete(`/userFeedBackInfo/deletePicture/${loginUserId}`,
      {
        data: {
          picturePath: this.feedbackForm.newQuestionPicture
        }
      }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code === "200") {
      this.feedbackForm.newQuestionPicture = '';
    } else {
      ElMessage.warning(result.msg);
    }
  }).catch(error => {
    console.log("uploadPicture error:" + error);
    // ElMessage.error("系统异常，请联系管理员");
  });
}

function submitFeedBackData(feedBackForm, type) {
  request.post('/userFeedBackInfo/',
      {
        userId: loginUserId,
        questionId: this.questionId,
        areaId: this.areaId,
        examDate: feedBackForm.examDate,
        errorReason: feedBackForm.errorReason,
        suggestion: feedBackForm.newSuggestion,
        title: feedBackForm.newQuestionTitle,
        titleAudio: feedBackForm.newQuestionTitleAudio,
        answerText: feedBackForm.newQuestionAnswerText,
        answerAudio: feedBackForm.newQuestionAnswerAudio,
        picture: feedBackForm.newQuestionPicture,
        questionType: this.questionType,
        type: type,
        paperId: this.paperId,
        questionAnswers: feedBackForm.newQuestionOptions
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code === "200") {
      if (type === 'exam') {
        ElMessage.success("反馈信息已收到，感谢您的反馈!" + result.data);
      } else {

        ElMessage.success("反馈信息已收到，感谢您的反馈");
      }
      this.feedbackForm.newQuestionTitleAudio = '';
      this.feedbackForm.newQuestionAnswerText = '';
      this.feedbackForm.newQuestionTitle = '';
      this.feedbackForm.newQuestionAnswerAudio = '';
      this.feedbackForm.examDate = '';
      this.feedbackForm.errorReason = '';
      this.feedbackForm.newQuestionOptions = [];
      this.feedbackForm.newQuestionPicture = '';
      this.feedbackForm.newSuggestion = '';
      hasTitleRecord.value = false;
      hasAnswerRecord.value = false;
      this.$emit('submitFeedBack:value', "success");
      // this.paperContentInfo.questionOperationDtoList=result.data;
    } else {
      ElMessage.warning(result.msg);
      // router.push("/login");
    }
  }).catch(error => {
    console.log("feedback error:" + error);
    // ElMessage.error("系统异常，请联系管理员");
  });
}

// const questionId = ref('');
// const paperId = ref('');
// const areaId = ref('');
const newQuestionOptions = ref([
]);

const newQuestionAnswerAudio = ref('');
const newQuestionTitleAudio = ref('');
const titlePlayer = ref(new Audio());
const titlePlayerUrl = ref('');
const answerPlayer = ref(new Audio());
const answerPlayerUrl = ref('');

const showAnswerRecord = ref(false);
const showTitleRecord = ref(false);
const hasAnswerRecord = ref(false);
const hasTitleRecord = ref(false);
const paperFontSize = ref('18px');
const hasSuggestion = ref(false);
const feedBackType = ref('hasExam');

export default {
  name: "FeedBack",
  components: {recordComponents: recordComponent},
  created() {
    if (this.chooseType === 'suggestion') {
      feedBackType.value = "hasSuggestion";
      this.feedBackSuggestion();
    }
  },
  data() {
    return {
      paperFontSize: paperFontSize,
      hasExam: true,
      hasError: false,
      feedBackType: feedBackType,
      newQuestion: false,
      hasSuggestion: hasSuggestion,
      feedbackForm: {
        examDate: '',
        errorReason: '',
        newSuggestion: '',
        newQuestionTitle: '',
        newQuestionTitleAudio: newQuestionTitleAudio,
        newQuestionAnswerText: '',
        newQuestionAnswerAudio: newQuestionAnswerAudio,
        newQuestionPicture: '',
        newQuestionOptions: newQuestionOptions
      },
      showAnswerRecord: showAnswerRecord,
      showTitleRecord: showTitleRecord,
      hasAnswerRecord: hasAnswerRecord,
      titlePlayerUrl: titlePlayerUrl,
      hasTitleRecord: hasTitleRecord,
      answerPlayerUrl: answerPlayerUrl,
      feedBackRules: {
        examDate: [
          {required: true, message: '请选择考试日期', trigger: 'blur'}
        ],
        errorReason: [
          {required: true, message: '请输入错误原因及答案', trigger: 'blur'}
        ],
        newSuggestion: [
          {required: true, message: '请输入建议', trigger: 'blur'}
        ],
        newQuestionTitle: [
          {required: true, message: '请输入题目', trigger: 'blur'}
        ],
        newQuestionTitleAudio: [
          {required: true, message: '请提供题目语音', trigger: 'blur'}
        ],
        newQuestionAnswerText: [
          {required: true, message: '请输入答案', trigger: 'blur'}
        ],
        newQuestionAnswerAudio: [
          {required: true, message: '请提供语音答案', trigger: 'blur'}
        ],
        newQuestionPicture: [
          {required: true, message: '请提供图片', trigger: 'blur'}
        ],
      }
    }

  },
  methods: {
    feedBackExam() {
      this.hasExam = true;
      this.hasError = false;
      this.newQuestion = false;
      hasSuggestion.value = false;
    },
    feedBackError() {
      this.hasExam = false;
      this.hasError = true;
      this.newQuestion = false;
      hasSuggestion.value = false;
    },
    feedBackNew() {
      this.hasExam = false;
      this.hasError = false;
      this.newQuestion = true;
      hasSuggestion.value = false;
      if (this.questionType === 'judgement') {
        newQuestionOptions.value = [{content: '', answer: true}, {content: '', answer: false}]
      }
      if (this.questionType === 'singleChoice' || this.questionType === 'multiChoice') {
        newQuestionOptions.value = [{content: '', answer: true},
          {content: '', answer: false},
          {content: '', answer: false},
          {content: '', answer: false}]
      }
    },
    feedBackSuggestion() {
      this.hasExam = false;
      this.hasError = false;
      this.newQuestion = false;
      hasSuggestion.value = true;
    },
    getFeedBackType() {
      if (this.hasExam) {
        return "exam";
      }
      if (this.hasError) {
        return "error";
      }
      if (hasSuggestion.value) {
        return "suggestion";
      }
      if (this.newQuestion) {
        return "newQuestion";
      }
    },
    submitFeedBack() {
      this.$refs.feedbackForm.validate(async (valid) => {
        if (valid) {
          submitFeedBackData.call(this, this.feedbackForm, this.getFeedBackType());
          setTimeout(function () {
            if (titlePlayerUrl.value !== '') {
              URL.revokeObjectURL(titlePlayerUrl.value)
              titlePlayerUrl.value = ''
            }
            if (answerPlayerUrl.value !== '') {
              URL.revokeObjectURL(answerPlayerUrl.value)
              titlePlayerUrl.value = ''
            }
          }, 5000);
        }
      });
    },

    beforeUpload(file) {
      //这里设置上传图片类型和限制大小
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        ElMessage.error("图片必须是jpg或png格式！");
        return false;
      } else if (file.size / 1024 / 1024 > 5) {
        ElMessage.error("图片过大！");
        return false;
      }
      return true;
    },
    beforeAudioUpload(file) {
      if (file.type !== "audio/mpeg") {
        ElMessage.error("音频文件必须是.mp3格式！");
        return false;
      } else if (file.size / 1024 / 1024 > 5) {
        ElMessage.error("文件过大！");
        return false;
      }
      return true;
    },
    limitError() {
      ElMessage.error("图片仅可上传1张");
    },
    uploadPicture(file) {
      uploadPictureToServer.call(this, file);
    },
    removePicture(file) {
      if (this.$confirm(`确定移除 ${file.name}？`)) {
        deletePictureFromServer.call(this);
      }
    },
    removeOption(index) {
      newQuestionOptions.value.splice(index, 1);
    },
    addOption() {
      newQuestionOptions.value.push({
        content: '',
        answer: false,
      });
    },
    handleTitleRecordDialog(value) {
      if (value != null) {
        uploadRecord.call(this, value, "title");
        titlePlayerUrl.value = URL.createObjectURL(value);
        showTitleRecord.value = false;
        hasTitleRecord.value = true;
      }
    },
    handleAnswerRecordDialog(value) {
      if (value != null) {
        uploadRecord.call(this, value, "answer");
        answerPlayerUrl.value = URL.createObjectURL(value);
        showAnswerRecord.value = false;
        hasAnswerRecord.value = true;
      }
    },
    recordAnswerAudio() {
      showAnswerRecord.value = true;
    },
    recordTitleAudio() {
      showTitleRecord.value = true;
    },
    removeTitleAudio() {
      if (this.feedbackForm.newQuestionTitleAudio === "" || this.feedbackForm.newQuestionTitleAudio == null) {
        hasTitleRecord.value = false;
        newQuestionTitleAudio.value = '';
        return ElMessage.info("删除成功");
      }
      this.$confirm(`确定移除 ${this.feedbackForm.newQuestionTitleAudio.slice(-8)}？`).then(() => {
        deleteAudioFromServer.call(this, this.feedbackForm.newQuestionTitleAudio, "title");
      })
    },
    removeAnswerAudio() {
      if (this.feedbackForm.newQuestionAnswerAudio === "" || this.feedbackForm.newQuestionAnswerAudio == null) {
        hasAnswerRecord.value = false;
        newQuestionAnswerAudio.value = '';
        return ElMessage.info("删除成功");
      }
      this.$confirm(`确定移除 ${this.feedbackForm.newQuestionAnswerAudio.slice(-8)}？`).then(() => {
        deleteAudioFromServer.call(this, this.feedbackForm.newQuestionAnswerAudio, "answer");
      })
    },
    uploadAnswerAudio(file) {
      if (file != null) {
        uploadRecord.call(this, file.file, "answer");
        hasAnswerRecord.value = true;
        titlePlayerUrl.value = URL.createObjectURL(file.file);
      }
    },
    uploadTitleAudio(file) {
      if (file != null) {
        uploadRecord.call(this, file.file, "title");
        hasTitleRecord.value = true;
        titlePlayerUrl.value = URL.createObjectURL(file.file);
      }
    },
    titleText2Audio() {
      if (this.feedbackForm.newQuestionTitle == null || this.feedbackForm.newQuestionTitle === '') {
        return ElMessage.error("请输入题目");
      }
      text2AudioTitle.call(this, this.feedbackForm);
      hasTitleRecord.value = true;
    },
    titlePlay() {
      titlePlayer.value.play();
    },
    titlePlayerPause() {
      titlePlayer.value.pause();
    },
    answerPlay() {
      answerPlayer.value.play();
    },
    answerPlayerPause() {
      answerPlayer.value.pause();
    },
    answerText2Audio() {
      if (this.feedbackForm.newQuestionAnswerText == null || this.feedbackForm.newQuestionAnswerText === '') {
        return ElMessage.error("请输入答案");
      }
      text2AudioAnswer.call(this, this.feedbackForm);
      hasAnswerRecord.value = true;
    },
  }

}
</script>
<script setup>
import {defineProps} from 'vue'
import {QuestionFilled} from "@element-plus/icons-vue";

// const props = ['questionId', 'paperId', 'areaId']
defineProps({
  questionId: {
    type: Number, default: 0
  },
  paperId: {
    type: String, default: ''
  },
  areaId: {
    type: String, default: ''
  },
  questionType: {
    type: String, default: 'singleChoice'
  },
  chooseType: {
    type: String, default: ''
  }
})
</script>

<style scoped>
.image-uploader .el-upload {
  border: 1px dashed black !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-radio :deep(.el-radio__label) {
  font-size: v-bind(paperFontSize);
  line-height: 2;
  color: black;
  /*margin-right: 15px;*/
  white-space: normal;
  word-break: break-all;
}

.el-radio :deep(.el-radio__inner) {
  width: v-bind(paperFontSize);
  height: v-bind(paperFontSize);
  border-color: black;
}

.el-radio :deep(.el-radio__input.is-checked + .el-radio__label) {
  color: black;
}

.el-radio :deep( .el-radio__input.is-checked .el-radio__inner) {
  border-color: blue; /* 选中边框的颜色 */
  background-color: blue; /* 选中背景的颜色 */
}

.el-card-class {
  width: 630px;
}

</style>
